var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Box, FormControl, Typography } from "@mui/material";
import { useElementConditions, useFormLogic, } from "../../context/FormLogicContext";
import { isValueEmpty } from "../../../../utils/forms-functions";
import { getElementValueKey } from "../../../../utils/helpers";
import Header from "../common/Header";
import { applyExpressionFormat, getExpressionValueAsStr, } from "./constants/expression";
var ExpressionField = function (_a) {
    var element = _a.element;
    var formValues = useFormLogic().formValues;
    var isVisible = useElementConditions(element).isVisible;
    var valueKey = getElementValueKey(element);
    var displayValue = useMemo(function () {
        var _a;
        var value = (_a = formValues[valueKey]) !== null && _a !== void 0 ? _a : element.defaultValue;
        if (isValueEmpty(value)) {
            return "";
        }
        return applyExpressionFormat(getExpressionValueAsStr(value, element), element.format);
    }, [formValues, valueKey, element]);
    if (!isVisible)
        return null;
    return (_jsx(Box, __assign({ className: "component-wrapper" }, { children: _jsxs(FormControl, __assign({ fullWidth: true, sx: { mb: 3 } }, { children: [_jsx(Header, { element: element }), _jsx(Typography, __assign({ variant: "body1", "data-testid": "expression-field-".concat(element.name) }, { children: displayValue }))] })) })));
};
export default ExpressionField;
